export default __webpack_public_path__ + "cb2d81b17cf2a2a6ef06412ba9e51c1f.png";